import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {IScheduleSettings} from "../../../../Interfaces/Schedule.interfaces";
import {ClassNameMap} from "notistack";
import SimpleForm from "../../../Atoms/SimpleForm";

interface Props {
    schedule: IScheduleSettings["schedule"],
    listConfig: IScheduleSettings["schedule"]["listConfig"],
    toggleHidePastEvents: Function,
    globalClasses: ClassNameMap
}
const HidePastEvents = ({globalClasses, schedule, listConfig, toggleHidePastEvents} : Props) =>{
    return (
        <Card>
            <CardHeader classes={{ root: globalClasses.cardHeader }} title="Hide Past Events?" />
            <CardContent>
                {schedule && schedule.listConfig && listConfig.shouldHidePastEvents && (
                    <Typography variant="body1">Only future events will appear for users.</Typography>
                )}
                {schedule && schedule.listConfig && !listConfig.shouldHidePastEvents && (
                    <Typography variant="body1">
                        Both past and future events will appear for users.
                    </Typography>
                )}

                <SimpleForm
                    defaultValues={{
                        shouldHidePastEvents:
                            listConfig && listConfig.shouldHidePastEvents
                                ? listConfig.shouldHidePastEvents
                                : false,
                    }}
                    fields={[
                        {
                            name: 'shouldHidePastEvents',
                            type: 'toggle',
                        },
                    ]}
                    hideButton={true}
                    id="Toggle-past-events-display"
                    onSubmit={(val: boolean) => toggleHidePastEvents(val)}
                    submitOnChange={true}
                />
            </CardContent>
        </Card>
    )
}

export default HidePastEvents;